import { Component, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

const handleFirstTab = (e: KeyboardEvent): void => {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');

        window.removeEventListener('keydown', handleFirstTab);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
};

const handleMouseDownOnce = (): void => {
    document.body.classList.remove('user-is-tabbing');

    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
};

export class A11yWrapper extends Component<Props> {
    async componentDidMount(): Promise<void> {
        // The overall goal here is to remove the blue focus outline app-wide in an
        // accessibility-friendly way. The 'user-is-tabbing' class is added on the first Tab keydown.
        // If there is a subsequent mousedown, it is removed. See app.css for implementation.
        window.addEventListener('keydown', handleFirstTab);
    }

    componentWillUnmount(): void {
        window.removeEventListener('keydown', handleFirstTab);
        window.removeEventListener('mousedown', handleMouseDownOnce);
    }

    render(): ReactNode {
        const {
            props: { children },
        } = this;

        return children;
    }
}
